export enum ResponsiveBreakPoint {
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1440
}
